import React from 'react';
import {
  Props,
} from 'pages/Dashboard/pages/Charts/pages/Details/types/tabContentProps';
import LedgerView from 'pages/Dashboard/pages/Ledger/LedgerView';

export default function Ledger({ patient: patientInfo }: Props) {
  return (
    <div className="-mx-4 -mb-4 flex flex-col !h-[calc(100%+16px)] overflow-hidden">
      <LedgerView patient={patientInfo} />
    </div>
  );
}
